import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Hyperlink } from '@offerzen/pinata'

import ApplicationStatusChip from '@/CandidateExperience/components/ApplicationStatusChip'
import { ApplicationStatus } from '@/CandidateExperience/constants/applicationStatus'

import DescriptionList, { DescriptionItem } from '@/Jobs/components/DescriptionList'

import styles from './styles'

const getApplicationStatusCopy = ({ applicationStatus, candidateSlug }) => {
  const applicationStatusCopyMap = {
    [ApplicationStatus.Pending]: 'Your application has been sent to the company.',
    [ApplicationStatus.Declined]: 'The company has declined your application.',
    [ApplicationStatus.Accepted]: (
      <>
        Continue the conversation with this company in your{' '}
        <Hyperlink label="Interviews" href={`/candidate/${candidateSlug}/interview_requests`} as={Link} /> inbox.
      </>
    ),
  }

  return applicationStatusCopyMap[applicationStatus]
}

const AppliedContent = ({ applicationStatus, candidateSlug }) => {
  if (!applicationStatus) return null

  return (
    <div className={styles.appliedContent}>
      <h4>You&apos;ve applied for this job.</h4>

      <DescriptionList>
        <DescriptionItem term="Status" details={<ApplicationStatusChip applicationStatus={applicationStatus} />} />
      </DescriptionList>

      <p>{getApplicationStatusCopy({ applicationStatus, candidateSlug })}</p>
    </div>
  )
}

AppliedContent.propTypes = {
  candidateSlug: PropTypes.string,
  applicationStatus: PropTypes.oneOf(Object.values(ApplicationStatus)),
}

export default AppliedContent
